module.exports = __webpack_public_path__ + "static/img/20230710_02.32edd49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230710_02.png
// module id = e1p3
// module chunks = 0